































import {Component, Prop, Watch} from 'vue-property-decorator';
import Vue from 'vue';
import {MemberInitState, StarTransactionAVG} from '@/store/member/member.types';
import {MemberServiceType} from '@/store/member/member.enum';
import {State} from 'vuex-class';

@Component({
  components: {}
})
export default class StarRatingComponent extends Vue {
  @State('member') memberInitState!: MemberInitState;

  public starList = [
    {
      title: 'การให้บริการ',
      avg: 0,
      data: [{
        point: 123,
        rating: 1
      },
      ]
    }, {
      title: 'การรับบริการ',
      avg: 0,
      data: [{
        point: 123,
        rating: 1
      },
      ]
    }];
  public starTransaction = [] as StarTransactionAVG[];
  public starSize = 15;

  async mounted() {
    this.setStartForComponent();
  }

  async init() {
    this.setStartForComponent();
  }

  async setStartForComponent() {
    this.starTransaction = this.memberInitState.component.profileVisit.starTransaction;
    if (!this.starTransaction) {
      return;
    }
    let a = this.starTransaction.filter((r) => {
      return r.service_type === MemberServiceType.ServiceProvider;
    });
    let b = this.starTransaction.filter((r) => {
      return r.service_type === MemberServiceType.ServiceReceiver;
    });
    this.starList[0].data = [];
    this.starList[1].data = [];
    let aTotal = 0, aRows = 0;
    let bTotal = 0, bRows = 0;
    for (let i = 0; i < 5; i++) {
      let aIndex = a.map((r) => {
        return r.point
      }).indexOf(i + 1);
      let bIndex = b.map((r) => {
        return r.point
      }).indexOf(i + 1);

      if (aIndex !== -1) {
        this.starList[0].data.push({
          rating: i + 1,
          point: parseInt(a[aIndex].count_rows)
        });
        aRows += parseInt(a[aIndex].count_rows);
        aTotal += parseInt(a[aIndex].count_rows) * (i + 1)
      } else {
        this.starList[0].data.push({
          rating: i + 1,
          point: 0
        });
      }
      this.starList[0].avg = aTotal / aRows;

      if (bIndex !== -1) {
        this.starList[1].data.push({
          rating: i + 1,
          point: parseInt(b[bIndex].count_rows)
        });
        bRows += parseInt(b[bIndex].count_rows);
        bTotal += parseInt(b[bIndex].count_rows) * (i + 1)
      } else {
        this.starList[1].data.push({
          rating: i + 1,
          point: 0
        });
      }
      this.starList[1].avg = bTotal / bRows;
    }
    console.log('DEBUG: this.starTransaction', this.starTransaction);
  }

}
